var t = require('i18n').t
var AccountSelectorMixin = require('../mixins/account-selector')
var _ = require('lodash')
var Scope = require('../utils/scope')
var NOTIFICATION_KEYS = require('../notificationKeys')
var PARTNER_BANK_NAMES = ['shine', 'kontist']

module.exports = Em.Controller.extend(AccountSelectorMixin, {
    queryParams: {
        bankConnectionSuccess: 'success',
        /* may not be needed */
        bankConnectionError: 'error',
        bankConnectionEstablished: 'bankConnectionEstablished',
        period: 'period',
        sortProperty: 'sortProperty',
        sortDirection: 'sortDirection',
        status: 'status',
        transactionType: 'transactionType',
        searchQuery: 'searchQuery'
    },

    api: Em.inject.service(),

    status: null,

    bankConnectionEstablished: null,

    auth: Em.inject.service(),

    segment: Em.inject.service(),

    needs: ['organization', 'bankAccount', 'bank-sync-matches'],

    account: Em.computed.alias('controllers.bankAccount.model'),

    bankConnections: Ember.inject.service(),

    bankAccounts: Ember.inject.service(),

    lastBankEntryDate: null,

    shouldShowConnectButton: false,

    shouldDisplayRenewConnectionButton: false,

    hasBankIntegration: false,

    hasBankConnections: false,

    hasBankMatches: false,

    hasPostings: false,

    lastUpdate: null,

    expiredBankSession: null,

    isLoaded: false,

    period: null,

    sortProperty: null,

    sortDirection: null,

    transactionType: undefined,

    searchQuery: undefined,

    sortPropertyOptions: function() {
        return [
            {
                value: 'entryDate',
                label: t('bank_sync.entry_date')
            },
            {
                value: 'sideAmount',
                label: t('bank_sync.amount')
            }
        ]
    }.property(),

    isPageLoaded: function() {
        return this.get('isLoaded') && this.get('bankConnections.isLoaded') && this.get('bankAccounts.isLoaded')
    }.property('isLoaded', 'bankConnections.isLoaded', 'bankAccounts.isLoaded'),

    isBankSyncReadAuthorized: function() {
        return this.get('auth').isAuthorized(Scope.BankSyncRead)
    }.property(),

    isBankSyncWriteAuthorized: function() {
        return this.get('auth').isAuthorized(Scope.BankSyncWrite)
    }.property(),

    isBankStatementImportAuthorized: function() {
        return this.get('auth').isAuthorized(Scope.BankStatementImport)
    }.property(),

    hasPartnerBankConnection: function() {
        var accountName = this.get('account.name') && this.get('account.name').toLowerCase().trim()
        return PARTNER_BANK_NAMES.includes(accountName)
    }.property('account.name'),

    showReconciledTransactions: function() {
        var status = this.get('status')
        return status === 'reconciled'
    }.property('status'),

    withAuthorization: function(onAuthorized) {
        return this.get('auth').withAuthorization(
            onAuthorized,
            Scope.BankSyncWrite,
            'bank_account_overview_connect_bank'
        )
    },
    showNoBankLinesToReconcileEmptyView: function() {
        var currentAccountId = this.get('account.id')
        var bankConnectionFromReact = this.get('bankConnections.bankConnection')
        var bankConnectedToCurrentAccount = this.get('bankConnections.data') && this.get('bankConnections.data').find(function(c) {
            return c.externalAccountId === currentAccountId
        })
        var hasBankConnection = !!bankConnectionFromReact || !!bankConnectedToCurrentAccount

        return hasBankConnection || this.get('searchQuery') || this.get('hasPartnerBankConnection')
    }.property('account.id', 'bankConnections.bankConnection', 'searchQuery', 'hasPartnerBankConnection'),

    canConnectToBank: function() {
        return this.get('isBankSyncWriteAuthorized') && !this.get('hasPartnerBankConnection')
    }.property('hasBankIntegration', 'bankConnections.bankConnection', 'hasPartnerBankConnection'),

    shouldShowBankStatement: function() {
        return this.get('isBankStatementImportAuthorized')
    }.property(),

    getLastSyncDate: function() {
        var bankAccount = this.get('bankConnections.bankConnection')
        if (bankAccount) {
            var lastTimeUpdated = this.get('bankConnections.bankConnection.lastSynchronizedAt') || this.get('bankConnections.bankConnection.lastPullTime')
            var lastPullTimeFormatted = lastTimeUpdated ? moment(lastTimeUpdated).format('MMM DD YYYY, HH:mm') : null
            this.set('lastUpdate', lastPullTimeFormatted)
        } else {
            this.set('lastUpdate', null)
        }
    }.observes('bankConnections.bankConnection'),

    shouldShowConnectBankView: function() {
        if (this.get('bankConnectionSuccess') === 'true' || this.get('bankConnectionEstablished') === 'true' || this.get('hasPartnerBankConnection')) {
            return false
        }

        var hasBankMatches = this.get('hasBankMatches')
        var hasPostings = this.get('hasPostings')
        var currentAccountId = this.get('account.id')

        var bankConnectedToCurrentAccount = this.get('bankConnections.data') && this.get('bankConnections.data').find(function(c) {
            return c.externalAccountId === currentAccountId
        })
        var hasBankConnection = !!bankConnectedToCurrentAccount

        return !hasBankConnection && !hasBankMatches && !hasPostings
    }.property('account.id', 'hasBankMatches', 'hasPostings', 'success', 'bankConnectionEstablished', 'hasPartnerBankConnection'),

    resetAccountSpecificData: function() {
        this.set('hasBankMatches', null)
        this.set('hasPostings', null)
        this.set('lastBankEntryDate', null)
        this.set('hasBankIntegration', null)
        this.set('bankConnections.bankConnection', null)
        this.set('bankConnectionEstablished', null)

        var matchesController = this.get('controllers.bank-sync-matches')
        if (matchesController) {
            matchesController.set('_isPollingActive', false)
            matchesController.stopPolling()

            // This is to prevent filter changes during account setup
            matchesController.set('_isInitialLoad', true)
        }

        this.checkAndStartPolling(false)
    }.observes('account.id'),

    checkAndStartPolling: function(forcePolling) {
        var currentAccountId = this.get('account.id')
        var bankConnection = this.get('bankConnections.data') && this.get('bankConnections.data').find(function(c) {
            return c.externalAccountId === currentAccountId
        })

        if (!bankConnection || !bankConnection.createdAt) {
            return false
        }

        var createdAt = new Date(bankConnection.createdAt).getTime()
        var elapsedTime = Date.now() - createdAt
        var timeLimit = 5 * 60 * 1000

        if (elapsedTime < timeLimit || forcePolling) {
            var matchesController = this.get('controllers.bank-sync-matches')
            if (matchesController) {
                matchesController.startPollingIfNewConnection()
                this.set('isLoaded', true)
                return true
            }
        }

        return false
    },

    loadBankMatches: function() {
        this.set('isLoaded', false)

        var self = this
        var matchesController = this.get('controllers.bank-sync-matches')

        var currentAccountId = this.get('account.id')
        var api = this.container.lookup('api:billy')
        var accountStatementUrl = '/accounts/' + currentAccountId + '/statement?limit=1'

        var matchesPromise = matchesController.load()
            .then(function(matches) {
                return new Em.RSVP.Promise(function(resolve) {
                    // Wait for matches controller to load, to prevent returning old values
                    function checkLoaded() {
                        if (matchesController.get('isLoaded')) {
                            var lastBankEntry = _.chain(matches).sortBy('entryDate').last().get('entryDate').value()
                            self.set('lastBankEntryDate', lastBankEntry)
                            self.set('hasBankMatches', matches && matches.length > 0)
                            resolve(matches)
                        } else {
                            Ember.run.next(checkLoaded)
                        }
                    }
                    checkLoaded()
                })
            })
            .catch(function() {
                self.container.lookup('util:notification').warn(NOTIFICATION_KEYS.BANK_SYNC_LOAD, t('util.request.default_error'))
                self.set('hasBankMatches', false)
                return []
            })

        var statementPromise = api.get(accountStatementUrl).then(function(payload) {
            if (payload) {
                var accountStatement = payload.accountStatement
                if (accountStatement && accountStatement.rows && accountStatement.rows.length > 0) {
                    self.set('hasPostings', true)
                }
            } else {
                self.set('hasPostings', false)
            }
        })

        Ember.RSVP.allSettled([matchesPromise, statementPromise])
            .then(function() {
                self.set('isLoaded', true)
            })
    },

    openBankSettingsModal: function() {
        this.withAuthorization(function() {
            this.container.lookup('component:bank-settings-modal')
                .set('accountId', this.get('account.id'))
                .show()
        }.bind(this))
    },

    actions: {
        didClickImport: function() {
            this.transitionToRoute('bank_import')
            this.get('segment').track('XXX - Reconciliation account Options Opened (Client)', {
                action: 'import_transactions'
            })
        },
        didClickBankSettings: function() {
            this.openBankSettingsModal()
            this.get('segment').track('XXX -Reconciliation account Options Opened (Client)', {
                action: 'open_bank_settings'
            })
        },

        didClickAccountStatement: function() {
            this.transitionToRoute('bank_account')
            this.get('segment').track('XXX - Reconciliation Account Overview Viewed (Client)')
        }
    },

    customActions: {
        checkBankIntegration: function(e) {
            if (e.detail.connectedBankData) {
                this.set('hasBankIntegration', true)
                this.set('shouldShowConnectButton', false)
            } else {
                this.set('hasBankIntegration', false)
                this.set('shouldShowConnectButton', true)
            }
            this.set('bankConnections.bankConnection', e.detail.connectedBankData)
            this.set('bankConnections.isLoadingBankConnection', false)
        },

        changeReconcileStatus: function(e) {
            var status = e.detail.status || undefined
            this.set('status', status)
        }
    }
})
